import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router'
import Switch from './form/Switch';
import BodyClass from './BodyClass';
import { setPhase } from '../actions';
import { connect } from 'react-redux';

class Nav extends Component {
	render() {
		const { dispatch, phases: { p1, p2, p3 } } = this.props;

		return (
			<div className="nav">
				<div className="nav-heading">
					<img src="/assets/img/library/bee-logo.svg" />
				</div>
				<div className="nav-list">
					<div className="nav-item">
						<Link to="dashboard" activeClassName="nav-item__active-link">Dashboard</Link>
					</div>
					<div className="nav-item">
						<Link to="content" activeClassName="nav-item__active-link">Content Library</Link>
					</div>
					<div className="nav-item">
						<Link to="edit" activeClassName="nav-item__active-link">New Article</Link>
					</div>
					<div className="nav-item">
						<a href="#" onClick={this.props.toggleMediaOverlay}>Media</a>
					</div>					
					<div className="nav-item disabled">Author</div>
					<div className="nav-item disabled">Collections</div>
					<div className="nav-item disabled">Configuration</div>
				</div>
				<BodyClass className={p1 && 'phase-1'} />
				<BodyClass className={p2 && 'phase-2'} />
				<BodyClass className={p3 && 'phase-3'} />
				<div className="phases-toggle-container">
					<Switch value={p1} label="Phase 1" onChange={(value) => dispatch(setPhase(1, value))} />
					<Switch value={p2} label="Phase 2" onChange={(value) => dispatch(setPhase(2, value))} />
					<Switch value={p3} label="Phase 3" onChange={(value) => dispatch(setPhase(3, value))} />
				</div>
				<div className="nav-toolbelt">
					<a href="http://toolbelt.cnbc.com">
						<i className="iconcss icon-toolbelt-logo"></i> Go to toolbelt
					</a>
				</div>
			</div>
		)
	}
}
const mapStateToProps = (state) => {
	return {
		phases: state.phases
	}
}

export default connect(mapStateToProps)(Nav);
